<template>
  <div class="card">
    <div class="image">
      <img v-if="card === 0" src="/media/vetrina/industrie_alimentari.jpg" alt="alimentari photo"/>
      <img v-if="card === 1" src="/media/vetrina/industrie_non_alimentari.jpg" alt="non alimentari photo"/>
    </div>
    <div class="my-text">
      <h3 v-if="card === 0" class="my-caps d-flex align-items-center">
        <img src="\media\icons\svg\pannocchia.svg" alt=""/>
        <span class="my-caps">
        {{ trans.get('public.home.ind.food') }}
        </span
        >
      </h3>
      <h3 v-if="card === 1" class="my-caps d-flex align-items-center">
        <img src="\media\icons\svg\fabbrica.svg" alt=""/>
        <span class="my-caps">
          {{ trans.get('public.home.ind.non-food') }}
        </span>
      </h3>
      <p v-if="card === 0">
        {{ trans.get('public.home.ind.desc') }}
      </p>
      <p v-if="card === 1">
        {{ trans.get('public.home.ind.desc1') }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "industrie-card",
  props: ["card"],
  data() {
    return {};
  },
  mounted() {
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.card {
  font-size: 1em;
  @media (min-width: 1921px){
    font-size: var(--font-size-large);
  }
  border: 0;
  box-shadow: unset;
  background-color: inherit !important;
 margin-right: 20px;
  .my-text {
    color: #fff
  }
}

.row {
  color: #fff;

  h3 {
    img {
      margin-right: 10px;
    }
  ;
    color: #fff;
    padding: 20px 0;
  }
}

@media (max-width: 576px) {
  .card {
    margin: 0;
  }
.my-text {
  margin-top: 28px;
  margin-bottom: 54px;
  img {
    margin-left: 20px;
  }
  h3.my-caps {
    padding: 0;
    font-size: 18px;
  }
  p {
    margin: 0 20px;
  }
}
}
@media (min-width: 1621px) {

}
</style>
